import '../scss/app.scss'
import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { Provider } from 'react-redux'

import BadgeDetails from './BadgeDetails'
import configureStore from '../store/configureStore'
const store = configureStore();

class App extends React.Component {
  render () {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route path="/badges/:id" component={BadgeDetails} />
            <Route path="/credit/:id" component={BadgeDetails} />
          </Switch>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App
